import { LinearGradient as ExpoLinearGradient } from 'expo-linear-gradient';
import React, { PureComponent } from 'react';
import {
  Animated, Dimensions, Easing, Platform, StyleSheet, View,
} from 'react-native';
import { LinearGradient as ReactNativeLinearGradient } from 'react-native-linear-gradient';
import Theme from '../../theme';

interface IProps {
  containerStyle?: {
    height?: string | number,
    width?: string | number,
    backgroundColor?: string,
    marginTop?: number,
    marginBottom?: number,
    marginLeft?: number,
    marginRight?: number,
    margin?: number,
    borderRadius?: number;
  };
}

const { width: SCREEN_WIDTH } = Dimensions.get('window');
// todo: extract this logic into a shared place, and try to use the same package on both platforms
const LinearGradient = Platform.OS === 'ios' ? ReactNativeLinearGradient : ExpoLinearGradient;

export class SkeletonLoader extends PureComponent<IProps> {
  private animatedValue = new Animated.Value(0);

  private translateX = this.animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [-SCREEN_WIDTH, SCREEN_WIDTH],
  });

  private AnimatedLinearGradient = Animated.createAnimatedComponent(LinearGradient);

  public componentDidMount() {
    Animated.loop(
      Animated.timing(this.animatedValue, {
        toValue: 1,
        duration: 1200,
        easing: Easing.linear,
        useNativeDriver: true,
      }),
    ).start();
  }

  public render() {
    return (
      <View style={[styles.container, this.props.containerStyle]}>
        <this.AnimatedLinearGradient
          colors={[Theme.WHITE, Theme.GREY_LIGHT, Theme.GREY_LIGHT, Theme.WHITE]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          style={[StyleSheet.absoluteFill, { transform: [{ translateX: this.translateX }] }]}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: SCREEN_WIDTH,
    height: 150,
    backgroundColor: Theme.WHITE,
    overflow: 'hidden',
    borderRadius: 3,
  },
});
